import { useAtomValue } from 'jotai';

import { Divider,Stack } from '@ekhodealer/ekho-common/rev';

import { useGetLeadDetails } from '@common/api/leads/useGetLeadDetails';
import { AccordionSection } from '@common/components/AccordionSection';
import { InfoLineItem } from '@common/components/InfoLineItem';

import { leadDetailsDrawerAtom } from '../../atoms/leadDetailsDrawerAtoms';

const SECTION_TITLE = 'Contact info';

export const ContactInfoSection = () => {
	const { selectedRow } = useAtomValue(leadDetailsDrawerAtom);
	const { data: leadDetails } = useGetLeadDetails(selectedRow?.id);

	if (!leadDetails || !selectedRow?.id) {
		return null;
	}

	const { contactInfo } = leadDetails;

	return (
		<>
			<Divider />
			<AccordionSection title={SECTION_TITLE} defaultExpanded>
				<Stack itemsSpacing='12'>
					<InfoLineItem title='Name' value={contactInfo.name} isCopyable />
					<InfoLineItem title='Phone number' value={contactInfo.phone} isCopyable />
					<InfoLineItem title='Email' value={contactInfo.email} isCopyable />
					<InfoLineItem title='Address' value={contactInfo.address} isCopyable />
				</Stack>
			</AccordionSection>
		</>
	);
};
